module.exports = __webpack_public_path__ + "static/media/9.125211e0.png";